/* eslint-disable */
// import invariant from 'invariant';

export const GoogleApi = function (opts) {
  opts = opts || {};

  // invariant(opts.hasOwnProperty('apiKey'),
  //   'You must pass an apiKey to use GoogleApi');

  // const apiKey = opts.apiKey;
  // const callback = opts.callback;
  const libraries = opts.libraries || ['places'];
  const client = opts.client;
  const URL = 'https://maps.googleapis.com/maps/api/js';

  const googleVersion = opts.version || '3.30';

  const script = null;
  const google = window.google || null;
  const loading = false;
  // const channel = opts.channel;
  const language = opts.language;
  const region = opts.region;

  const onLoadEvents = [];

  const url = () => {
    const url = URL;
    const params = {
      // key: apiKey,
      libraries: libraries.join(','),
      // callback: callback,
      client,
      v: googleVersion,
      // channel,
      language,
      region,
    };

    const paramStr = Object.keys(params)
      .filter(k => !!params[k])
      .map(k => `${k}=${params[k]}`).join('&');

    return `${url}?${paramStr}`;
  };

  return url();
};

export default GoogleApi;
